import { useState, useRef } from 'react';
import DOMPurify from 'dompurify';
import SendFeedback from '../function/SendFeedback';
import CustomSelect from '../inputs/CustomSelect';
import { useNotification } from './NotificationContext';
import '../css/feedback.css';

export default function WriteFeedback({ username, inputs, onClose }) {
  const { showNotification } = useNotification();

  const FEEDBACK_OPTIONS = [
    '-- Select a category --',
    'Give a compliment',
    'Report a problem',
    'Make a suggestion',
  ];

  const [feedbackType, setFeedbackType] = useState(FEEDBACK_OPTIONS[0]);
  const textRef = useRef(null);

  const validate = () => {
    const text = textRef.current?.value.trim();

    if (feedbackType === FEEDBACK_OPTIONS[0]) {
      showNotification({
        type: 'error',
        title: 'Missing Category',
        message: 'Please choose a feedback category.',
      });
      return false;
    }

    if (!text) {
      showNotification({
        type: 'error',
        title: 'Missing Message',
        message: 'Please type your feedback.',
      });
      return false;
    }

    return true;
  };

  const handleSubmit = async () => {
    if (!validate()) return;

    const payload = {
      type: feedbackType,
      username,
      inputs,
      feedback: DOMPurify.sanitize(textRef.current.value),
    };

    try {
      await SendFeedback(payload);

      showNotification({
        type: 'success',
        title: 'Feedback Sent',
        message: 'Thank you for helping us improve!',
      });

      onClose?.();
    } catch (err) {
      showNotification({
        type: 'error',
        title: 'Feedback Failed',
        message: err.message,
      });
    }
  };

  return (
    <div className="feedback-panel">
      <button className="remove-button button-warning" onClick={onClose}>
        ✕
      </button>
      <CustomSelect
        value={feedbackType}
        onChange={setFeedbackType}
        optionChoice={FEEDBACK_OPTIONS}
      />
      <textarea
        ref={textRef}
        className="feedback-textarea"
        placeholder="Type your feedback here..."
      />
      <button className="button-sm button-gray" onClick={handleSubmit}>
        Send
      </button>
    </div>
  );
}
